function isEmpty(value: any) {
    if (value === null || value === undefined) {
        return true;
    }

    if (typeof value === "string" || Array.isArray(value)) {
        return value.length === 0 || value === "";
    }

    if (typeof value === "object") {
        // 파일 객체의 경우
        if (value instanceof FileList) {
            return value.length === 0;
        }

        // 일반 객체의 경우
        return Object.keys(value).length === 0;
    }

    return false;
}

export { isEmpty };
